import React, { useEffect, useState } from 'react';
import { Nav, TabContainer, TabContent, TabPane } from 'react-bootstrap';
import './RecurringMessagePromptTabs.scss'
export default function RecurringMessagePromptTabs({ tabs }) {
    return (
        <TabContainer
            defaultActiveKey={tabs[0]?.name}
            className={`list-section-container-content-bar`}
        >
            <Nav className="list-section-container-content-bar nav nav-tabs recurring-message-prompt-tab-container">
                {tabs.map((tab) => (
                    <Nav.Link key={tab.name} className="nav-item" eventKey={tab.name}>
                        {tab.name}
                    </Nav.Link>
                ))}
            </Nav>
            <TabContent className='recurring-message-tab-item'>
                {tabs.map((tab, index) => (
                    <TabPane eventKey={tab.name} key={index}>
                        {tab.content}
                    </TabPane>
                ))}
            </TabContent>
        </TabContainer>
    );
};